import React, { useContext } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { ButtonType } from '@/components/atoms/button'
import { modalContainerStyle } from '@/components/pages/accommodation-management/list-layout'
import { LoaderContextCreator } from '@/contexts/loader'
import { useSelfCheckOutState } from '@/hooks/use-self-check-out-state'
import { useHistory } from 'react-router-dom'
import { FrontTabletButton } from '@/components/molecules/front-tablet/button'
import { reportError } from '@/components/apps/error-boundary'

type Props = {
  message: string
  onCancel: () => void
}

export const CheckoutConfirmDialog: React.FC<Props> = props => {
  const { t, i18n } = useTranslation()
  const history = useHistory()
  const { state, doCheckOut } = useSelfCheckOutState()
  const { setIsLoading } = useContext(LoaderContextCreator())

  const onConfirm = async () => {
    try {
      setIsLoading(true)
      await doCheckOut(state, i18n.language)
      history.replace({ pathname: '/self-checkout/complete' })
    } catch (e) {
      reportError(e)
      alert(t('Please complete the procedure at the front desk'))
      history.push({ pathname: `/self-checkin`, search: `?hotelId=${state.hotelId}` })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div css={modalContainerStyle} style={{ display: 'flex' }}>
      <div css={modalBodyContainerStyle}>
        <div css={modalMainContainerStyle}>
          <div css={contentStyle}>
            <Trans i18nKey={props.message} />
          </div>
        </div>
        <div css={modalButtonSectionStyle}>
          <FrontTabletButton buttonType={ButtonType.NonStyle} onClick={props.onCancel}>
            {t('Back')}
          </FrontTabletButton>
          <FrontTabletButton buttonType={ButtonType.Primary} onClick={onConfirm}>
            {t('SelfCheckIn.Confirm')}
          </FrontTabletButton>
        </div>
      </div>
    </div>
  )
}

const contentStyle = css({
  background: 'white',
  width: '100%',
  borderRadius: 5,
  padding: 32,
  fontSize: 24,
})

const modalBodyContainerStyle = css({
  position: 'relative',
  margin: 'auto',
  width: 500,
  zIndex: 102,
  opacity: 1,
  background: '#FFF',
  borderRadius: 5,
})

const modalMainContainerStyle = css({
  backgroundColor: '#F2F2F2',
  display: 'flex',
})

const modalButtonSectionStyle = css({
  display: 'flex',
  gap: 16,
  padding: '11px 32px 11px 32px',
  justifyContent: 'space-between',
  boxShadow: '0px 0px 6px #0000001A',
})
